import { useNavigate } from 'react-router';

import { UserSession } from '~/data/auth.server'

import Logo from '~/icons/whiteLogo.svg'
import Instagram from '~/icons/instagram.svg'

interface Props {
  user?: UserSession | null
}

const Footer = ({ user }: Props) => {
  const navigate = useNavigate()

  return (
    <div className='my-4 p-4 md:p-10 rounded text-white bg-magenta'>
      <div className='flex md:justify-center gap-2'>
        <div className='w-1/3 flex flex-col gap-3 text-center'>
          <p className='mb-1 font-medium text-lg'>Search</p>
          <p className='text-sm'>
            <button onClick={() => navigate('/events/search')}>Events</button>
          </p>
          <p className='text-sm'>
            <button onClick={() => navigate('/artists/search')}>Artists</button>
          </p>
          <p className='text-sm'>
            <button onClick={() => navigate('/hosts/search')}>Hosts</button>
          </p>
        </div>
        <div className='w-1/3 flex flex-col gap-3 text-center'>
          <p className='mb-1 font-medium text-lg'>Join us</p>
          {!user && (
            <a className='text-sm' href='/auth/signup'>
              Sign up
            </a>
          )}
          <a className='text-sm' href='/artists/create'>
            For Artists
          </a>
          <a className='text-sm' href='/hosts/create'>
            For Hosts
          </a>
        </div>
        <div className='w-1/3 flex flex-col gap-3 text-center'>
          <p className='mb-1 font-medium text-lg'>About</p>
          <a className='text-sm' href='/featuresAndPricing'>
            Features
          </a>
          <p className='text-sm'>
            <button onClick={() => navigate('/aboutUs')}>About us</button>
          </p>
          <a className='text-sm' href='/contactUs'>
            Contact us
          </a>
        </div>
      </div>
      <div className='flex flex-col md:flex-row gap-4 items-center justify-center mt-6'>
        <p className='text-lg font-medium'>Looking to host your next event?</p>
        <button
          className='mb-1 text-left border-white border-[1px] py-2 px-4 rounded-button'
          onClick={() => navigate('/auth/signUp')}
        >
          Sign up
        </button>
      </div>
      <hr className='solid my-4' />
      <div className='flex justify-between'>
        <button onClick={() => navigate(user ? '/events/feed' : '/')}>
          <img src={Logo} alt='logo_icon' />
        </button>
        <div className='flex flex-col md:flex-row gap-2 md:gap-6 items-center'>
          <a
            className='underline'
            href='/docs/privacy_and_cookie_policy.pdf'
            target='_blank'
          >
            Privacy Policy
          </a>
          <a
            className='underline'
            href='/docs/website_terms.pdf'
            target='_blank'
          >
            Terms
          </a>
        </div>
        <div className='hidden md:flex gap-4 items-center'>
          <p>© fannaan 2025 (ABN 93 683 385 999)</p>
          <a
            href='https://www.instagram.com/fannaan_events'
            target='_blank'
            rel='noreferrer'
            className='bg-white rounded-button h-icon w-icon flex items-center justify-center'
          >
            <img src={Instagram} alt='instagram_icon' />
          </a>
        </div>
      </div>
    </div>
  )
}

export default Footer
